import { Subject } from 'rxjs'
import { Input, Injector } from '@angular/core'
import { UIEvent, UIEventHub } from '../services/event.service'
import { LoadingService } from '@ar2/common'

/**
 * ウィジェットの共通基底クラス
 * @author nabla2.metamodel.generator
 */
export abstract class BaseWidget {
  /**
   * 項目識別子
   */
  @Input() id:string

  /**
   * 項目論理名
   */
  @Input() title:string

  /**
   * 子項目識別子
   */
  @Input() childrenKeys:string[]

  public eventHub: UIEventHub

  public event$: Subject<UIEvent<any>> = new Subject<UIEvent<any>>()

  public loadingService: LoadingService

  constructor(
    public injector: Injector,
  ) {
    this.eventHub = injector.get(UIEventHub)
    this.loadingService = injector.get(LoadingService)
    this.event$.debounceTime(300).subscribe(event => {
      this.eventHub.next(event)
    })
  }

  get htmlId():string {
    return this.id
  }

  /**
   * コンポーネント内で発生したイベントを通知する。
   * @param eventType イベント種別
   * @param index 序数(リスト項目の場合のみ)
   */
  on(eventType:string|{type:string}, index?:number) {
    if (this.loadingService.showLoading) return
    const type = (typeof eventType === 'string') ? eventType : eventType.type
    this.event$.next({
      id: this.id,
      type: type,
      source: {},
      index: index,
    })
  }
}

export abstract class BaseColumnComponent extends BaseWidget {

  /**
   * リスト内容
   */
  @Input() records:any[]

  constructor(
      public injector: Injector,
  ) {
    super(injector);
  }
  /**
   * Vertical accordion icons setting
   *
   * @memberof ColorCodeColumn
  */
  public verticalAcdnIcons = {
    opening: 'fr-chevron-down',
    closing: 'fr-chevron-right',
  }
  /**
   * グループの1番目の項目かどうかをチェック
   * @memberof ColorCodeColumn
   */
  firstItemOfGroup(key: string, index: number): boolean {
    let prev = this.getRecordData(index - 1, key)
    let self = this.getRecordData(index, key)
    let next = this.getRecordData(index + 1, key)
    return self && self === next && prev !== self
  }
  /**
   * 行番号、キーでデータを取得
   * @memberof ColorCodeColumn
   */
  getRecordData(i: number, key: string) {
    if (i < 0 || i >= this.records.length) return null
    return this.records[i][key]
  }
  /**
   * グループの親項目かどうかををチェック
   * @memberof ColorCodeColumn
   */
  hasGroup(groupItems: string[], index: number): boolean {
    if (!groupItems || !this.records) return false
    let flg = false
    let level = 0
    groupItems.forEach((key, i) => {
      if (this.firstItemOfGroup(key, index)) {
        flg = true
        level = i
      }
    })
    if (flg) {
      if (level === 0) {
        this.records.slice(index + 1).forEach((data, i) => {
          if (data[groupItems[0]] === this.getRecordData(index, groupItems[0])) {
            this.records[i + index + 1]._showFlg = !!this.records[index]._openFlg
          }
        })
      } else {
        this.records.slice(index + 1).forEach((data, i) => {
          if (data._showFlg !== false && data[groupItems[1]] === this.getRecordData(index, groupItems[1])) {
            this.records[i + index + 1]._showFlg = !!this.records[index]._openFlg
          }
        })
      }
    }
    return flg
  }
  /**
   * 左パディングの幅を取得
   * @memberof ColorCodeColumn
   */
  paddingLeft(groupItems: string[], index: number): string {
    if (!groupItems || !this.records) return null
    let padding = null
    groupItems.forEach((key, i) => {
      let prev = this.getRecordData(index - 1, key)
      let self = this.getRecordData(index, key)
      if (self && self === prev) {
        padding = 23 * (i + 1) + 'px'
      }
    })
    return padding
  }
  /**
   * グループを開く
   * @memberof ColorCodeColumn
   */
  openGroup(index: number) {
    if (!this.records || index < 0 || index >= this.records.length) return
    this.records[index]._openFlg = !this.records[index]._openFlg
  }
  /**
   * 垂直アコーディオンのアイコン名を取得
   * @param i number
   */
  verticalAcdnIcon(index: number): string {
    return !!this.records[index]._openFlg ? this.verticalAcdnIcons.opening
                                          : this.verticalAcdnIcons.closing
  }
}
    


// WEBPACK FOOTER //
// ./src/widgets/base-widget.ts